import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// i18n yapılandırmasını içe aktarıyoruz
import './i18n/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 